import { render, staticRenderFns } from "./AppCustomer.vue?vue&type=template&id=e4505228&scoped=true&"
import script from "./AppCustomer.vue?vue&type=script&lang=js&"
export * from "./AppCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AppCustomer.vue?vue&type=style&index=0&id=e4505228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4505228",
  null
  
)

export default component.exports